<div class="flex flex-col gap-2">
  <div
    class="mt-4 flex w-full items-center justify-center"
    data-testid="multi-upload-drop-zone"
    (dragover)="preventDefaultAndStopPropagation($event)"
    (dragleave)="preventDefaultAndStopPropagation($event)"
    (drop)="onDropFile($event)">
    <label
      class="flex w-full cursor-pointer flex-col items-center justify-center rounded-lg border-2 border-dashed border-gray-200 hover:bg-gray-300">
      <div class="flex flex-col items-center justify-center pt-5 pb-6">
        <svg aria-hidden="true" class="size-17">
          <use href="@shared-core/icons/drag-n-drop-files.svg#drag-n-drop-files"></use>
        </svg>
        <p class="mb-2 text-sm text-gray-500 dark:text-gray-400">
          Ziehen Sie Dateien hier rein oder wählen Sie Dateien aus.
        </p>
        <p class="text-xs text-gray-500 dark:text-gray-400">
          {{ acceptedFormatsText() }} (zusammen max. {{ allowedMaxTotalSizeMegaBytes() }} MB)
        </p>
      </div>
      <input
        type="file"
        class="hidden"
        multiple
        (change)="addFile($event)"
        [accept]="acceptedFormats().join(',')"
        data-testid="multi-upload-input" />
    </label>
  </div>

  <shared-ui-upload-file-items [files]="files()" (removeFile)="onClickDeleteFile($event.file)" />
</div>
